<script setup lang="ts">
import Slider from "@vueform/slider";
import '@vueform/slider/themes/default.css'

const props = defineProps({
  min: {
    type: Number,
    required: false,
    default: 0,
  },
  max: {
    type: Number,
    required: false,
    default: 100,
  },
  step: {
    type: Number,
    required: false,
    default: 1,
  },
  modelValue: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const filterValue = computed({
  get() {
    return props.modelValue.length ? props.modelValue : [props.min, props.max];
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

</script>

<template>
  <div class="flex flex-col space-y-6">
    <div class="flex flex-row space-x-4">
      <p-input
        rounded=""
        typeInput="number"
        width="small"
        :min="min"
        :max="max"
        style-input="gray"
        height="small"
        disabled
        class="pl-3"
        style="background: none"
        v-model="filterValue[0]"
        :placeholder="`от ${min}`"
        outlined
      >
        <template #prepend>
          <span class="absolute left-1 text-gray-600" >от</span>
        </template>
      </p-input>
      <p-input
        rounded=""
        :min="min"
        :max="max"
        typeInput="number"
        width="small"
        class="pl-3"
        style-input="gray"
        disabled
        height="small"
        v-model="filterValue[1]"
        :placeholder="`до ${max}`"
        outlined
      >
        <template #prepend>
          <span class="absolute left-1 text-gray-600" >до</span>
        </template></p-input
      >
    </div>
    <Slider
      v-model="filterValue"
      class="slider-primary"
      :tooltips="false"
      :min="min"
      :max="max"
      :step="step"
    />
  </div>
</template>

<style scoped>
.slider-primary {
  --slider-connect-bg: #485070;
  --slider-tooltip-bg: #485070;
  --slider-handle-ring-color: #48507026;
  --slider-handle-bg: #485070;
  --slider-bg: #e9eaf1;
  --slider-handle-width: 12px;
  --slider-handle-height: 12px;
  --slider-height: 4px;
}
</style>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
</style>
